export function getSliderPercentage(position, duration) {
  if (!position || !duration) {
    return 0;
  }
  return Math.floor((position / duration) * 100);
}
